import { FastWarrantiesComponent } from './components/fast-warranties/fast-warranties.component';
import { RentalAdministrationComponent } from './components/guaranties/rental-administration/rental-administration.component';
import { NewWarrantyComponent } from './components/guaranties/new-warranty/new-warranty.component';
import { WarrantyDetailsComponent } from './components/guaranties/warranty-details/warranty-details.component';
import { EditTenantComponent } from './components/tenants/edit-tenant/edit-tenant.component';
import { SettingsComponent } from './components/settings/settings.component';
import { DigitalSignaturesComponent } from './components/digital-signatures/digital-signatures.component';
import { NotificationDetailsComponent } from './components/notifications/notification-details/notification-details.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { TenantDetailsComponent } from './components/tenants/tenant-details/tenant-details.component';
import { TenantsComponent } from './components/tenants/tenants.component';
import { PasswordResetComponent } from './components/session/password-reset/password-reset.component';
import { AuthorizationConfirmComponent } from './components/authorizations/authorization-confirm/authorization-confirm.component';
import { ServiceDetailsComponent } from './components/services/service-details/service-details.component';
import { EditServiceComponent } from './components/services/edit-service/edit-service.component';
import { ServicesComponent } from './components/services/services.component';
import { ReportDetailsComponent } from './components/reports/report-details/report-details.component';
import { ReportsComponent } from './components/reports/reports.component';
import { TenantsPaymentFormSendedComponent } from './components/tenants/tenants-payment-form/tenants-payment-form-sended/tenants-payment-form-sended.component';
import { TenantsPaymentFormComponent } from './components/tenants/tenants-payment-form/tenants-payment-form.component';
import { TenantCustomFormSendedComponent } from './components/tenants/tenant-custom-form/tenant-custom-form-sended/tenant-custom-form-sended.component';
import { TenantCustomFormComponent } from './components/tenants/tenant-custom-form/tenant-custom-form.component';
import { QuoteDetailsComponent } from './components/quotes/quote-details/quote-details.component';
import { NewQuoteComponent } from './components/quotes/new-quote/new-quote.component';
import { QuotesComponent } from './components/quotes/quotes.component';
import { GuarantiesComponent } from './components/guaranties/guaranties.component';
import { PropertyDetailsComponent } from './components/properties/property-details/property-details.component';
import { EditPropertyComponent } from './components/properties/edit-property/edit-property.component';
import { OwnerDetailsComponent } from './components/owners/owner-details/owner-details.component';
import { EditOwnerComponent } from './components/owners/edit-owner/edit-owner.component';
import { OwnersComponent } from './components/owners/owners.component';
import { BrokerDetailsComponent } from './components/brokers/broker-details/broker-details.component';
import { OfficeDetailsComponent } from './components/offices/office-details/office-details.component';
import { EditOfficeComponent } from './components/offices/edit-office/edit-office.component';
import { OfficesComponent } from './components/offices/offices.component';
import { BrokerHomeComponent } from './components/home/broker-home/broker-home.component';
import { OfficeHomeComponent } from './components/home/office-home/office-home.component';
import { Injectable, NgModule } from '@angular/core';
import { Routes, RouterModule, Route, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CorporateHomeComponent } from './components/home/corporate-home/corporate-home.component';
import { LoginComponent } from './components/session/login/login.component';
import { AuthService } from './services/auth.service';
import { BrokersComponent } from './components/brokers/brokers.component';
import { EditBrokerComponent } from './components/brokers/edit-broker/edit-broker.component';
import { PropertiesComponent } from './components/properties/properties.component';
import { ExternalBrokerAccessComponent } from './components/external-broker-access/external-broker-access.component';
import { CurrencyComponent } from './components/currencies/currency/currency.component';
import { ExchangeRateComponent } from './components/currencies/exchange-rate/exchange-rate.component';
import { ContractsComponent } from './components/contracts/contracts.component';
import { NewContractComponent } from './components/contracts/new-contract/new-contract-component';
import { ContractDetailsComponent } from './components/contracts/contract-details/contract-details.component';
import { ZonasComponent } from './components/calculadora/zonas/zonas.component';
import { EditZonaComponent } from './components/calculadora/zonas/edit-zona/edit-zona.component';
import { TiposDescuentoComponent } from './components/calculadora/tipos-descuento/tipos-descuento.component';
import { EditTipoDescuentoComponent } from './components/calculadora/tipos-descuento/edit-tipo-descuento/edit-tipo-descuento.component';
import { MediosPagoComponent } from './components/calculadora/medios-pago/medios-pago.component';
import { EditMedioPagoComponent } from './components/calculadora/medios-pago/edit-medio-pago/edit-medio-pago.component';
import { CoberturasComponent } from './components/calculadora/coberturas/coberturas.component';
import { EditCoberturaComponent } from './components/calculadora/coberturas/edit-cobertura/edit-cobertura.component';
import { TiposFianzaComponent } from './components/calculadora/tipos-fianza/tipos-fianza.component';
import { EditTipoFianzaComponent } from './components/calculadora/tipos-fianza/edit-tipo-fianza/edit-tipo-fianza.component';
import { ServiciosContratadosComponent } from './components/calculadora/servicios-contratados/servicios-contratados.component';
import { EditServicioContratadoComponent } from './components/calculadora/servicios-contratados/edit-servicio-contratado/edit-servicio-contratado.component';
import { ComercialesComponent } from './components/comerciales/comerciales.component';
import { EditComercialComponent } from './components/comerciales/edit-comercial/edit-comercial.component';
import { ProductoComponent } from './components/calculadora/producto/producto.component';
import { ProductoDetalleComponent } from './components/calculadora/producto/producto-detalle/producto-detalle.component';

export function parentRoute(path: string, children: Route[], pathMatch: 'prefix' | 'full' = 'prefix') {
    return {
        path,
        pathMatch,
        children
    };
}

export function route(path: string, component: any, requireAuth: boolean, pathMatch: 'prefix' | 'full' = 'prefix') {
    return {
        path,
        component,
        pathMatch,
        canActivate: [AuthService],
        data: {
            requireAuth
        }
    };
}

@Injectable()
export class CanActivateHome implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const user = this.authService.getUser();
        if (user?.tipo === 'CORPORATIVO') {
            this.router.navigate(['corporativo', 'home']);
        } else if (user?.tipo === 'OFICINA') {
            this.router.navigate(['oficina', 'home']);
        } else if (user?.tipo === 'AGENTE') {
            this.router.navigate(['agente', 'home']);
        } else {
            this.authService.logout();
            this.router.navigate(['login']);
        }
        return false;
    }
}

const routes: Routes = [
    route('login', LoginComponent, false),
    route('remax-acceso-agente', ExternalBrokerAccessComponent, undefined),
    { path: 'home', component: LoginComponent, canActivate: [CanActivateHome] },
    parentRoute('corporativo', [
        route('home', CorporateHomeComponent, true),
    ]),
    parentRoute('oficina', [
        route('home', OfficeHomeComponent, true),
    ]),
    parentRoute('agente', [
        route('home', BrokerHomeComponent, true),
    ]),
    parentRoute('oficinas', [
        route('', OfficesComponent, true, 'full'),
        route('nueva', EditOfficeComponent, true),
        parentRoute(':id', [
            route('', OfficeDetailsComponent, true),
            route('editar', EditOfficeComponent, true),
        ]),
    ]),
    parentRoute('agentes', [
        route('', BrokersComponent, true, 'full'),
        route('nuevo', EditBrokerComponent, true),
        parentRoute(':id', [
            route('', BrokerDetailsComponent, true),
            route('editar', EditBrokerComponent, true),
        ]),
    ]),
    parentRoute('propietarios', [
        route('', OwnersComponent, true, 'full'),
        route('nuevo', EditOwnerComponent, true),
        parentRoute(':id', [
            route('', OwnerDetailsComponent, true),
            route('editar', EditOwnerComponent, true),
        ]),
    ]),
    parentRoute('propiedades', [
        route('', PropertiesComponent, true, 'full'),
        route('nueva', EditPropertyComponent, true),
        parentRoute(':id', [
            route('', PropertyDetailsComponent, true),
            route('editar', EditPropertyComponent, true),
        ]),
    ]),
    parentRoute('garantias', [
        route('', GuarantiesComponent, true, 'full'),
        route('nueva', NewWarrantyComponent, true),
        parentRoute(':id', [
            route('', WarrantyDetailsComponent, true, 'full'),
            route('administracion', RentalAdministrationComponent, true),
        ])
    ]),
    parentRoute('contratos', [
        route('', ContractsComponent, true, 'full'),
        route('nueva', NewContractComponent, true),
        route(':id', ContractDetailsComponent, true)
    ]),
    parentRoute('cotizaciones', [
        route('', QuotesComponent, true, 'full'),
        route('nueva', NewQuoteComponent, true),
        route(':id', QuoteDetailsComponent, true),
    ]),
    parentRoute('informes', [
        route('', ReportsComponent, true, 'full'),
        route(':id', ReportDetailsComponent, true),
    ]),
    parentRoute('inquilinos', [
        route('', TenantsComponent, true, 'full'),
        parentRoute('documentacion', [
            route('', TenantCustomFormComponent, undefined, 'full'),
            route('listo', TenantCustomFormSendedComponent, undefined),
        ]),
        parentRoute('pago', [
            route('', TenantsPaymentFormComponent, undefined, 'full'),
            route('listo', TenantsPaymentFormSendedComponent, undefined),
        ]),
        parentRoute(':id', [
            route('', TenantDetailsComponent, true),
            route('editar', EditTenantComponent, true),
        ]),
    ]),
    parentRoute('servicios', [
        route('', ServicesComponent, true, 'full'),
        route('nuevo', EditServiceComponent, true),
        parentRoute(':id', [
            route('', ServiceDetailsComponent, true),
            route('editar', EditServiceComponent, true),
        ]),
    ]),
    parentRoute('autorizaciones', [
        route(':id/:dictum', AuthorizationConfirmComponent, undefined),
    ]),
    parentRoute('recuperacion', [
        route('', PasswordResetComponent, undefined, 'full'),
    ]),
    parentRoute('notificaciones', [
        route('', NotificationsComponent, true, 'full'),
        route(':id', NotificationDetailsComponent, true),
    ]),
    parentRoute('firmas-pendientes', [
        route('', DigitalSignaturesComponent, true, 'full'),
    ]),
    parentRoute('garantias-rapidas', [
        route('', FastWarrantiesComponent, true, 'full'),
    ]),
    parentRoute('tipo-de-cambio', [
        route('', ExchangeRateComponent, true, 'full'),
        route('monedas', CurrencyComponent, true)
    ]),
    parentRoute('comerciales', [
        route('', ComercialesComponent, true, 'full'),
        route('nuevo', EditComercialComponent, true),
        route(':id/editar', EditComercialComponent, true),
    ]),
    parentRoute('configuracion', [
        route('', SettingsComponent, true, 'full'),
        parentRoute('calculadora', [
            parentRoute('zonas', [
                route('', ZonasComponent, true, 'full'),
                route('nueva', EditZonaComponent, true),
                route(':id/editar', EditZonaComponent, true),
            ]),
            parentRoute('tipos-descuento', [
                route('', TiposDescuentoComponent, true, 'full'),
                route('nueva', EditTipoDescuentoComponent, true),
                route(':id/editar', EditTipoDescuentoComponent, true),
            ]),
            parentRoute('medios-de-pago', [
                route('', MediosPagoComponent, true, 'full'),
                route('nuevo', EditMedioPagoComponent, true),
                route(':id/editar', EditMedioPagoComponent, true),
            ]),
            parentRoute('coberturas', [
                route('', CoberturasComponent, true, 'full'),
                route('nueva', EditCoberturaComponent, true),
                route(':id/editar', EditCoberturaComponent, true),
            ]),
            parentRoute('tipos-fianza', [
                route('', TiposFianzaComponent, true, 'full'),
                route('nueva', EditTipoFianzaComponent, true),
                route(':id/editar', EditTipoFianzaComponent, true),
            ]),
            parentRoute('producto', [
                route('', ProductoComponent, true, 'full'),
                route(':tipo', ProductoDetalleComponent, true),
            ]),
            parentRoute('servicios-contratados', [
                route('', ServiciosContratadosComponent, true, 'full'),
                route('nuevo', EditServicioContratadoComponent, true),
                route(':id/editar', EditServicioContratadoComponent, true),
            ]),
        ]),
    ]),
    { path: '**', pathMatch: 'full', redirectTo: '/home' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
